import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddExperienceComponent } from './add-experience/add-experience.component';
import { AllExperiencesComponent } from './all-experiences/all-experiences.component';


const routes: Routes = [
  {
    path: '',
    component: AllExperiencesComponent
  },
  {
    path: 'new',
    component: AddExperienceComponent
  },
  {
    path: ':id',
    loadChildren: () => import('./int-group-exp/int-group-exp.module').then(m => m.IntGroupExpModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExperiencesRoutingModule { }
